export class LancamentoAtividadeFactory {
  constructor(instance) {
    this.instance = instance;
  }

  createRegistroMaoDeObra(payload) {
    return this.instance.post(
      '/v1/reg-atividades/registro-por-maodeobra',
      payload,
    );
  }
}

export default (...params) => new LancamentoAtividadeFactory(...params);
